/**
 * Calculates the total available credit from billing payments
 * @param {Array} payments - Array of payment objects
 * @returns {number} Total available credit
 */
export const calculateTotalAvailable = (payments) => {
  if (!payments) return 0;
  
  return payments.reduce((total, payment) => {
    if (payment.type === 'credit' && payment.rate) {
      return total + (payment.amount / (payment.rate / 100));
    } else if (payment.type === 'withdrawal') {
      return total - payment.amount;
    } else if (payment.type === 'deposit') {
      return total + payment.amount;
    }
    return total;
  }, 0);
}; 